import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { PublisherStatsService } from '../../../../publisher/shared/services/publishers-stats.service';
import { BridgeAdUnit } from '../../../domain/bridge-ad-unit.model';
import { SortUtils } from '../../../utils/sort-utils';

@Component({
  selector: 'cm-unit-multiselect-search',
  templateUrl: './unit-multiselect-search.component.html',
  styleUrls: ['./unit-multiselect-search.component.scss'],
})
export class UnitMultiselectSearchComponent implements OnInit {
  @Input()
  initialData: string[];

  @Output()
  selectionChange = new EventEmitter<BridgeAdUnit[]>();

  selectAllIndeterminate;

  allUnits: BridgeAdUnit[] = [];
  filteredUnits: BridgeAdUnit[];
  selectedUnits: BridgeAdUnit[] = [];
  filterCtrl = new FormControl();

  constructor(private publishersService: PublisherStatsService) {
  }


  ngOnInit(): void {
    this.filterCtrl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged())
      .subscribe(next => {
        this.filteredUnits = this.allUnits.filter(item => {
          return (next && next === '') ? true : item.name.includes(next);
        });
      });

    this.getAllUnits();
  }

  private getAllUnits() {
    this.publishersService.getAdUnits().subscribe(next => {
      this.allUnits = this.prepareDate(next);
      this.filteredUnits = this.allUnits.slice();
      if (this.initialData) {
        this.selectedUnits = this.allUnits.filter(item => this.initialData.includes(item.id));
      }
    });
  }

  private prepareDate(addUnits: BridgeAdUnit[]): BridgeAdUnit[] {
    addUnits.sort(SortUtils.propertyComparatorString('name'));

    return addUnits;
  }


  onSelectionChange(event) {
    this.selectAllIndeterminate = this.selectedUnits.length === 0 ? false : true;
    this.emitChange();
  }

  // Reset filter is obligatory in case that search result do not show any value. 
  // Select will not open without at least one option value.
  onOpenedChange(event) {
    this.filterCtrl.setValue('');
  }

  onSelectAllChange(checked: boolean) {
    checked ? this.selectAll() : this.deselectAll();
  }

  selectAll() {
    this.selectedUnits = this.allUnits.slice(0);
    this.emitChange();
  }

  deselectAll() {
    this.selectedUnits = [];
    this.emitChange();
  }

  private emitChange() {
    this.selectionChange.emit(this.selectedUnits);
  }

}
